var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckCircleOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49605_299193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24 1.73494C36.2967 1.73494 46.2651 11.7033 46.2651 24C46.2651 36.2967 36.2967 46.2651 24 46.2651C11.7033 46.2651 1.73494 36.2967 1.73494 24C1.73494 11.7033 11.7033 1.73494 24 1.73494Z",
    fill: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0947 15.7469C13.0947 15.2912 13.4641 14.9219 13.9197 14.9219H27.666C28.1216 14.9219 28.491 15.2912 28.491 15.7469V27.6603C28.491 28.1159 28.1216 28.4853 27.666 28.4853H13.9197C13.4641 28.4853 13.0947 28.1159 13.0947 27.6603V15.7469ZM14.7447 16.5719V26.8353H26.841V16.5719H14.7447Z",
    fill: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.841 20.329C26.841 19.8734 27.2103 19.504 27.666 19.504H31.3316C31.5504 19.504 31.7603 19.5909 31.915 19.7456L34.6642 22.4949C34.8189 22.6496 34.9059 22.8594 34.9059 23.0782V27.6603C34.9059 28.116 34.5365 28.4853 34.0809 28.4853L27.666 28.4853C27.2103 28.4853 26.841 28.116 26.841 27.6603V20.329ZM28.491 21.154V26.8353H33.2559V23.42L30.9899 21.154H28.491Z",
    fill: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0435 28.4853C17.2339 28.4853 16.5775 29.1416 16.5775 29.9513C16.5775 30.761 17.2339 31.4174 18.0435 31.4174C18.8532 31.4174 19.5096 30.761 19.5096 29.9513C19.5096 29.1416 18.8532 28.4853 18.0435 28.4853ZM14.9275 29.9513C14.9275 28.2304 16.3226 26.8353 18.0435 26.8353C19.7645 26.8353 21.1596 28.2304 21.1596 29.9513C21.1596 31.6723 19.7645 33.0674 18.0435 33.0674C16.3226 33.0674 14.9275 31.6723 14.9275 29.9513Z",
    fill: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.957 28.4853C29.1473 28.4853 28.491 29.1416 28.491 29.9513C28.491 30.761 29.1473 31.4174 29.957 31.4174C30.7667 31.4174 31.423 30.761 31.423 29.9513C31.423 29.1416 30.7667 28.4853 29.957 28.4853ZM26.841 29.9513C26.841 28.2304 28.2361 26.8353 29.957 26.8353C31.6779 26.8353 33.073 28.2304 33.073 29.9513C33.073 31.6723 31.6779 33.0674 29.957 33.0674C28.2361 33.0674 26.841 31.6723 26.841 29.9513Z",
    fill: "#146EB4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49605_299193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckCircleOutlineIcon);
export default __webpack_public_path__ + "static/media/truck-circle-outline-icon.7411e9aab1a5322475b73ddf66183c11.svg";
export { ForwardRef as ReactComponent };